import { AssessmentType } from "../../../types/Assessment";
import { put } from "../../../utils/axios-config";
import { ASSESSMENTS } from "../../../utils/constants";

export const updateAssessment = async (data: AssessmentType) => await put<AssessmentType, string>(ASSESSMENTS, data);